import firebase from "../firebase";

const db = firebase.database().ref();

class AppointmentDataService {
  getAll() {
    return db;
  }

  create(appointment) {
    return db.push(appointment);
  }

  update(key, value) {
    return db.child(key).update(value);
  }

  delete(key) {
    return db.child(key).remove();
  }

  deleteAll() {
    return db.remove();
  }
}

export default new AppointmentDataService();
